import config from '../config';
import http from '../utils/http';

const { api } = config;

/**
 * Get clients.
 *
 * @return {Object}
 */
export async function fetchClients(id) {
    const url = `${api.endpoints.client}?tenantID=${id}`;
    const response = await http.get(url);

    return response;
}

/**
 * Get filtered clients.
 *
 * @return {Object}
 */
export async function fetchClientsByOrder(id, order) {
    const url = `${api.endpoints.client}&order=${order}?tenantID=${id}`;
    const response = await http.get(url);

    return response;
}

/**
 * Create new client.
 *
 * @return {Object}
 */
export async function createClient(data) {
    const url = api.endpoints.client;
    const response = await http.post(url, data);

    return response;
}

/**
 * Send feedback via email
 * @param data
 */
export async function sendFeedback(data) {
    const url = api.endpoints.feedback;
    try {
        const response = await http.post(url, data);
        return response;
    } catch (error) {
        console.error(error);
    }
}
